import React, { useRef, useEffect, useState } from 'react'

// Componentes PrimeReact
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';
import { InputText } from 'primereact/inputtext';


import { getProductosActivos } from '../../../../../API/Productos/ProductosRequests';
import AgGrid from '../../../../../Base/Components/Tables/AgGrid/AgGrid';

const ProductosOverlayPanel = ({ close, rowData, onChange }) => {

    const op = useRef(null);
    const buttom = useRef(null)
    const [loading, setLoading] = useState(false);
    const [productos, setProductos] = useState([]);


    const obtenerProductosActivos = async () => {
        setLoading(true);
        const tempo = await getProductosActivos();
        setProductos(tempo);
        setLoading(false)
    }

    const colums = [
        {
            header: 'Codigo',
            field: 'Codigo',
            className: 'small',

        },
        {
            header: 'Producto',
            field: 'Producto',
            className: 'Xlarge',
            flex: 1,
            Sumary: 'count',
        },
        {
            header: 'Categoria',
            field: 'Categoria',
        },
        {
            header: 'SubCategoria',
            field: 'SubCategoria',
            className: 'Xsmall',

        },
        {
            header: 'Unidad',
            field: 'Unidad',
            className: 'Xsmall',

        },
        {
            header: 'Inventario',
            field: 'Inventario',
            Format: 'Currency',
            className: 'Xsmall',
        },
        {
            header: 'Costo',
            field: 'Costo',
            Format: 'Currency',
            className: 'Xsmall',
        },

    ];

    const table = {
        Columns: colums,
        Data: productos,
        loading: loading,
        onCellClicked: e => onChange(e, rowData)
    }

    useEffect(() => {
        obtenerProductosActivos();
    }, [])

    return (
        <div style={{ maxWidth: '50vw' }}>

            <div className="p-inputgroup">
                <InputText value={rowData.NombreProducto} disabled placeholder="Producto" onClick={(e) => op.current.toggle(e)} />
                <Button ref={buttom} icon='pi pi-chevron-down' style={{ padding: '0.5rem 0.3rem' }} type="button" onClick={(e) => op.current.toggle(e)} />
            </div>

            <OverlayPanel ref={op} showCloseIcon dismissable={false} className='OverPanelProductos' onHide={close} >
                <div style={{ width: 1000, height: 300 }}>
                    <AgGrid table={table} />
                </div>
            </OverlayPanel>
        </div>
    )
}

export default ProductosOverlayPanel;
